import { css } from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return { text: css`
            ${custom.stepText};
            padding: 10px 0;
        ` }
}

export default styles
